import { get,post } from "@/util/httpCloud3DEH.js";
import globalVar from "@/util/globalVar";

//动态分页


export function detail(params) {
  // params.lang = globalVar.ApiLang;
  return post("/api/user/userInfo", params,);
}

// //最新
// export function getIndexData(params) {
//   // params.lang = globalVar.ApiLang;
//   return get("/client/applet/getIndexData", params);
// }


// WEBPACK FOOTER //
// ./src/api/login.js